import React, { useState, useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import './Appointment.css';
import emailjs from '@emailjs/browser';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { ButtonGroupButtonContext } from '@mui/material';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { Translate } from '@mui/icons-material';
import DatePick from './DatePick';




export default function Appointment(props) {

const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [message, setMessage] = useState("");
  const [alreadyVisited, setAlreadyVisited] = useState(false);
  const [appointmentmessage, setAppointmentMessage] = useState('');

  const isSubmitDisabled = !firstName || !mobileNumber;

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_xqanb2f', 'template_6jz5hy6', form.current, {
        publicKey: 'ky8BV5Qi_GPMIipf9',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
      setAppointmentMessage('The appointment is confirmed! You will get a call back soon!');
  };

  return (
    <div>
      <h2 style={{ textAlign: 'center', marginBottom: 10 }}>Appointment Form</h2>
      <div class="container text-center">
      <form  className="form-container" ref={form} onSubmit={sendEmail}>
        <div class="row" style={{ margin: 10 }}>

          <div class="input-group" style={{ padding: 0 }}>
            <input type="text" class="form-control form-control-lg" name="from_fname" placeholder="First Name (Required)" required value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ marginTop: 10, marginBottom: 10, alignItems: 'center' }} />
            <input type="text" class="form-control form-control-lg" name="from_lname" placeholder='Last Name' value={lastName} onChange={(e) => setLastName(e.target.value)} style={{ marginTop: 10, marginBottom: 10, alignItems: 'center' }} />
          </div>
          <input style={{ marginTop: 10, marginBottom: 10, alignItems: 'center' }} class="form-control form-control-lg" name="from_email" type="text" placeholder="Email" aria-label=".form-control-lg example" value={email} onChange={(e) => setEmail(e.target.value)}></input>
          <input style={{ marginTop: 10, marginBottom: 10, }} class="form-control form-control-lg" type="number" name="from_mobile" placeholder="Mobile Number (Required)" value={mobileNumber} required aria-label=".form-control-lg example" onChange={(e) => setMobileNumber(e.target.value)}></input>
          <input style={{ marginTop: 10, marginBottom: 10, }} class="form-control form-control-lg" type="text" name="message" placeholder="Message" aria-label=".form-control-lg example" value={message} onChange={(e) => setMessage(e.target.value)}></input>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" name ="alreadyvisited" id="AlreadyVisited1" checked={alreadyVisited}
                onChange={(e) => setAlreadyVisited(e.target.checked)} style={{ marginLeft: 100 }} />
            <label class="form-check-label" for="AlreadyVisited1" style={{ marginRight: 130 }}>
              Already Visited
            </label>
          </div>
          <DatePick />
          <button type="submit" class="btn btn-warning" value="Send" disabled={isSubmitDisabled} style={{ width: 500, alignItems: 'center', marginTop: 10, marginBottom: 10 }}>Submit</button>

        </div>
        </form>
        {appointmentmessage && <p style={{color:'green'}}>{appointmentmessage}</p>}
      </div>

    </div>
  )

}